import { useRef, useState, useEffect, useContext } from 'react'
import { Box, TextField, ImageList, ImageListItem, FormControl, InputLabel, Input, InputAdornment, IconButton, FormHelperText, Paper } from '@material-ui/core'
import { Image } from '@material-ui/icons'
import { uploadMedia, deleteMedia } from 'containers/Examination/ExaminationService'
import { ValidatorContext, QuestionItemContext } from 'containers/Examination/ExaminationContext'

import './QuestionDescription.css'

const QuestionDescription = (props) => {
  const { onChange, } = props
  const validator = useContext(ValidatorContext)
  const questionItem = useContext(QuestionItemContext)
  const descriptionFilePicker = useRef(null)

  const openDescriptionFilePicker = (e) => {
    e.preventDefault()
    descriptionFilePicker.current.click()
  }

  const [imagePreviews, setImagePreviews] = useState([])
  const [uploadingImage, setUploadingImage] = useState(false)

  const uploadQuestionMedia = async (e) => {
    setUploadingImage(true)

    const selectedFile = e.target.files[0]
    const formData = new FormData()
    formData.append('media', selectedFile)

    const image = await uploadMedia(formData)

    setUploadingImage(false)

    setImagePreviews((prevImages) => {
      return [...prevImages, image]
    })
  }

  const removeImage = (e, id) => {
    e.preventDefault()

    let updatedImage = imagePreviews.filter((img) => {
      deleteMedia(img.id)
      return img.id !== id
    })

    setImagePreviews(updatedImage)
  }

  const [description, setDescription] = useState('')
  const [helperText, setHelperText] = useState('')
  const [hasError, setHasError] = useState(false)

  useEffect(() => {
    onChange(description, imagePreviews)
  }, [description, imagePreviews, onChange])

  useEffect(() => {
    setHelperText('')
    setHasError(false)
    if (validator.validationError.description !== undefined && validator.validationError.description !== "") {
      setHelperText(validator.validationError.description)
      setHasError(true)
    }
  }, [validator])

  useEffect(() => {
    if (questionItem !== undefined && questionItem !== null) {
      setDescription(questionItem.description)
      setImagePreviews(questionItem.images)
    }
  }, [questionItem])

  return (
    <Box>
      <Box display="flex">
        <Box flexGrow={1}>
          <FormControl fullWidth>
            <InputLabel>Descibe your question</InputLabel>
            <Input
              type="text"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              error={hasError}
              fullWidth
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    onClick={openDescriptionFilePicker}
                  >
                    <Image />
                  </IconButton>
                  <input id="option-image-input" ref={descriptionFilePicker} type="file" onChange={uploadQuestionMedia} />
                </InputAdornment>
              }
            />
            <FormHelperText error={hasError}>{helperText}</FormHelperText>
          </FormControl>
        </Box>
      </Box>
      <Box display="flex">
        {imagePreviews?.length > 0 && <Paper style={{padding: '10px', width: '100%'}}>
          <ImageList rowHeight={160} cols={3} fullWidth>
            {imagePreviews.map((img) => (
              <ImageListItem key={img.id} cols={1}>
                <div className="image-overlay">
                  <a href="/" onClick={(e) => removeImage(e, img.id)}>
                    <i className="fa fa-times"></i>
                  </a>
                </div>
                <img src={img.photo_url} alt={img.photo_url} />
              </ImageListItem>
            ))}
            {uploadingImage &&
              <ImageListItem key={1} cols={1}>
                <div className="image-overlay placeholder">
                  <a href="/" onClick={(e) => e.preventDefault()}>
                    <i className="fa fa-spinner fa-spin"></i>
                  </a>
                </div>
                <img src="" alt="" />
              </ImageListItem>
            }
          </ImageList>
        </Paper>}
      </Box>
    </Box>
  )
}

export default QuestionDescription